/*******************************************************************************
* @ngdoc       provider
* @name        ChecksServiceProvider
* @module      csm.books.WriteChecks
* @description 
* Provides configuration of the ChecksService.
*******************************************************************************/
/* @ngInject */ export function ChecksServiceProvider() {
  this.$get = ['HTTPService', function(HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];  
  
  this.httpServiceBase = '/books/checks/';
  this.httpServices = {
    dropCheck: function (id) {
      return this.get('dropCheck/{0}'.format(id));
    },
    getCheck: function (id, dir) {
      return this.get('getCheck/{0}/{1}'.format(id || 0, dir || 0));
    },
    getCheckWritingAccounts() {
      return this.get('getCheckWritingAccounts');
    },
    getLastReconciledDate: function (accountID) {
      return this.get('getLastReconciledDate/{0}'.format(accountID));
    },
    requeueCheck: function (checkID) {
      return this.get('requeueCheck/{0}'.format(checkID));
    },
    saveCheck: function (data) {
      return this.post('saveCheck', data);
    },
    voidCheck: function (data) {
      return this.post('voidCheck', data);
    }
  };
};
